<template>
    <base-modal v-if="note" :title="title" :visible="true" @close="$emit('close')">
        <div v-for="topic in list.data"
             @click.stop="move(topic)"
             :class="{'active': note.topic && note.topic.id === topic.id}"
             :key="topic.id"
             class="topic">

            <i class="icon fas fa-copy"></i>
            {{ topic.name }}
        </div>
    </base-modal>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'NoteMoveModal',
    props: ['space', 'note'],
    computed: {
        ...mapState('topics', ['list']),
        title() {
            return `Move "${this.note.name || 'Untitled Note'}" note to ...`;
        },
    },
    methods: {
        async move(topic) {
            const note_topic_id = this.note.topic ? this.note.topic.id : null;
            const topic_id = topic ? topic.id : null;
            if (topic_id === note_topic_id) return;

            await this.$store.dispatch('notes/update', {
                space_id: this.space.id,
                note_id: this.note.id,
                data: { topic: topic_id, collection: null, is_private: false },
                patch: true,
            });
            this.$store.commit('tree/remove_open_note', this.note.id);
            this.$emit('moved', topic);
        },
    },
};
</script>

<style scoped>
    .topic {
        cursor: pointer;
        padding: 0.4rem;
    }

    .topic:hover, .topic.active {
        background: #ededed;
        border-radius: 3px;
    }
</style>
